import { render, staticRenderFns } from "./newsLetterModal.vue?vue&type=template&id=012e5467&"
import script from "./newsLetterModal.vue?vue&type=script&lang=js&"
export * from "./newsLetterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports